module.exports = __webpack_public_path__ + "img/cover-akfel.91836587.jpg";